window.AS.trackingHandler = window.AS.trackingHandler || {};

/*🤫
🤫
🤫
🤫
🤫
🤫*/
window.AS.trackingHandler = (function (w) {
  const { breakpoint } = window.o_global.device;
  let _currentBreakpoint = breakpoint.getCurrentBreakpoint();
  const { orientation } = window.o_global.device;
  let _currentOrientation = orientation.getCurrentOrientation();
  let breakpointTimer;
  let orientationTimer;

  orientation.registerChangeListener(function () {
    handleTrackingEvent(true, false);
  });

  /*🤫*/
  /*🤫*/
  breakpoint.registerChangeListener(function () {
    handleTrackingEvent(false, true);
  });

  /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
  function handleTrackingEvent(orientationChanged, breakpointChanged) {
    /*🤫*/
    /*🤫*/
    /*🤫*/
    if (orientationChanged && !breakpointChanged) {
      /*🤫*/
      orientationTimer = setTimeout(function () {
        if (_currentBreakpoint === breakpoint.getCurrentBreakpoint()) {
          sendTracking(true, false);
          _currentOrientation = orientation.getCurrentOrientation();
        } else {
          clearTimeout(breakpointTimer);
          breakpointTimer = undefined;
          sendTracking(true, true);
          updateLocalVars();
        }
      }, 500);
    } else {
      /*🤫*/
      breakpointTimer = setTimeout(function () {
        /*🤫*/
        if (!breakpointTimer) {
          return;
        }

        if (_currentOrientation === orientation.getCurrentOrientation()) {
          /*🤫*/
          sendTracking(false, true);
          _currentBreakpoint = breakpoint.getCurrentBreakpoint();
        } else {
          clearTimeout(orientationTimer);
          orientationTimer = undefined;
          sendTracking(true, true);
          updateLocalVars();
        }
      }, 500);
    }
  }

  /*🤫
🤫
🤫*/
  function updateLocalVars() {
    _currentOrientation = orientation.getCurrentOrientation();
    _currentBreakpoint = breakpoint.getCurrentBreakpoint();
  }

  /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
  function sendTracking(orientationChanged, breakpointChanged) {
    const sendData = {
      ot_BreakpointChange: breakpointChanged.toString(),
      ot_OrientationChange: orientationChanged.toString(),
    };

    if (window.o_util.misc.isPreview(w.location.href)) {
      return;
    }

    if (window.AS.testing.status().activated) {
      console.info(
        `[AS.trackinghandler]:${JSON.stringify(
          sendData
        )} BP: '${breakpoint.getCurrentBreakpoint()}', Orientation: '${orientation.getCurrentOrientation()}'`
      );
    }

    window.o_global.eventQBus.emit("tracking.bct.submitEvent", sendData);
  }

  /*🤫*/
  /*🤫
🤫
🤫
🤫
🤫*/
  function getCurrentOrientation() {
    return _currentOrientation;
  }

  /*🤫
🤫
🤫
🤫
🤫*/
  function setCurrentOrientation(cO) {
    _currentOrientation = cO;
  }

  /*🤫
🤫
🤫
🤫
🤫*/
  function getCurrentBreakpoint() {
    return _currentBreakpoint;
  }

  /*🤫
🤫
🤫
🤫
🤫*/
  function setCurrentBreakpoint(cB) {
    _currentBreakpoint = cB;
  }
  /*🤫*/

  return {
    /*🤫*/
    handleTrackingEvent,
    sendTracking,
    updateLocalVars,
    getCurrentBreakpoint,
    getCurrentOrientation,
    setCurrentBreakpoint,
    setCurrentOrientation,
    breakpoint,
    orientation,
    /*🤫*/
  };
})(window);
